import * as admin from "./definitions/admin";
import * as asyncTasks from "./definitions/async-tasks";
import * as authenticationSettings from "./definitions/authenticationSettings";
import * as company from "./definitions/company";
import * as dashboard from "./definitions/dashboard";
import * as easyAdd from "./definitions/easy-add";
import * as feedback from "./definitions/feedback";
import * as goals from "./definitions/goals";
import * as groups from "./definitions/groups";
import * as integrations from "./definitions/integrations";
import * as ipAddresses from "./definitions/ip-addresses";
import * as jobs from "./definitions/jobs";
import * as microsoftTeams from "./definitions/microsoftTeams";
import * as permissions from "./definitions/permissions";
import * as reportAnalytics from "./definitions/reportAnalytics";
import * as reporting from "./definitions/reporting";
import * as reviewAssignments from "./definitions/reviewAssignments";
import * as reviewCycles from "./definitions/reviewCycles";
import * as reviewForms from "./definitions/reviewForms";
import * as reviewReports from "./definitions/reviewReports";
import * as reviewTemplates from "./definitions/reviewTemplates";
import * as reviews from "./definitions/reviews";
import * as selectionObject from "./definitions/selectionObject";
import * as settings from "./definitions/settings";
import * as signatureTemplates from "./definitions/signatureTemplates";
import * as users from "./definitions/users";
import * as workflows from "./definitions/workflows";

export default [
	groups.GetGroup,
	groups.GetGroups,
	groups.DeleteGroup,
	groups.AddGroupAdmins,
	groups.UpdateGroupName,
	groups.AddGroupMembers,
	groups.RemoveGroupAdmins,
	groups.RemoveGroupMembers,
	groups.ChangeGroupPermission,

	authenticationSettings.getSamlObjects,
	authenticationSettings.changePassword,
	authenticationSettings.updateSamlObject,
	authenticationSettings.createSamlObject,
	authenticationSettings.deleteSamlObject,
	authenticationSettings.getAuthenticationMethods,
	authenticationSettings.userEmailAndPasswordLogin,
	authenticationSettings.updateAuthenticationMethods,
	authenticationSettings.getEnabledAuthenticationMethods,

	users.getMe,
	users.GetUserIsAdmin,
	users.PersonInput,
	users.GetUserInformation,
	users.DirectReportsCount,
	users.GetUserIsGroupAdmin,
	users.GetIsChainOfCommand,
	users.SearchEmployee,
	users.GetUserGustoData,

	permissions.GetDomainPermissions,
	permissions.GetObjectPermissions,
	permissions.GetRbacEmployeePermissions,
	permissions.GetRbacDomainPermissions,

	company.getFields,
	company.generateEmployeeCsv,
	company.GetGoalCategoryCount,

	easyAdd.GetReviewReportsAwaitingApproval,
	easyAdd.RespondReviewReportsAwaitingApproval,

	reviews.ReviewsGet,
	reviews.ReviewReportGetSingle,
	reviews.ReviewReportGetBulk,
	reviews.ReviewsGetBulk,
	reviews.TeamReviewsGetBulk,
	reviews.ReviewsGetEasyAdd,
	reviews.AddFormToReview,
	reviews.getAllReviews,
	reviews.DownloadReviewCsvJob,

	feedback.FeedbackRequestsGet,
	feedback.FeedbackRequestsDismiss,
	feedback.FeedbackRequestsCreate,
	feedback.RequestFeedbackCheck,
	feedback.FeedbackRequestsDelete,
	feedback.FeedbackRequestsEdit,

	reviewAssignments.reviewAssignmentsGetInfo,

	reviewCycles.createReviewCycle,
	reviewCycles.reviewCycleGetForms,
	reviewCycles.validateReviewCycleData,
	reviewCycles.bulkUpdateReviewCycleForms,
	reviewCycles.reviewCycleGetDetails,
	reviewCycles.reviewCycleGetInfo,
	reviewCycles.reviewCycleGetMeta,
	reviewCycles.addSubjectsToReviewCycle,
	reviewCycles.easyAddsApprove,
	reviewCycles.addEasyAdd,
	reviewCycles.editEasyAdd,
	reviewCycles.deleteEasyAdd,
	reviewCycles.addFormToCycle,
	reviewCycles.deleteFormsFromCycle,
	reviewCycles.replaceFormsInCycle,
	reviewCycles.bulkEasyAddsDeactivate,

	reviewTemplates.fetchTemplate,
	reviewTemplates.createTemplate,
	reviewTemplates.editTemplate,
	reviewTemplates.deleteTemplate,
	reviewTemplates.fetchBulkTemplates,

	jobs.GetJob,

	goals.GetGoal,
	goals.GoalsSearch,
	goals.getGoalOutlook,
	goals.getGoalOutlooks,
	goals.getGoalCategory,
	goals.getGoalCategories,

	admin.PostInvites,
	admin.BulkDeactivateUsers,
	admin.UserCsvUpload,
	admin.DismissDeactivateUsers,

	integrations.sendNetchexSettings,
	integrations.sendBambooHRSettings,
	integrations.sendIntegrationFields,
	integrations.GetHrisIntegrationInfo,
	integrations.GetHrisIntegrationUsers,
	integrations.getHrisIntegrationFields,
	integrations.resyncIntegrationWorkers,
	integrations.resyncIntegrationExternalFields,
	integrations.setIntegrationCredentials,
	integrations.getIntegrationCredentials,
	integrations.sendIntegrationConnections,
	integrations.UpdateGustoExternalCompanyID,
	integrations.addSftpIntegration,
	integrations.editSftpIntegration,
	integrations.getSftpIntegrations,
	integrations.getSftpIntegration,
	integrations.deleteSftpIntegration,
	integrations.getLog,
	integrations.checkCsvExists,
	integrations.getSignedURL,
	integrations.setWalkthroughFinished,
	integrations.getWalkthroughFinished,
	integrations.getDeactivatedEmployeeNames,
	integrations.getEmployeesRequiringApprovalToDeactivate,

	microsoftTeams.getTeamsConfig,
	microsoftTeams.getTeamsList,
	microsoftTeams.getTeamsMetadata,
	microsoftTeams.getTeamsInstallStatus,
	microsoftTeams.getChannelsOnTeam,
	microsoftTeams.installApp,
	microsoftTeams.updateTeamsSettings,

	ipAddresses.GetIPWhitelist,
	ipAddresses.AddIPToWhitelist,
	ipAddresses.GetCurrentIPAddress,
	ipAddresses.RemoveWhitelistItem,
	ipAddresses.EditWhitelistObject,
	ipAddresses.changeIPWhitelistSettings,

	workflows.LaunchWorkflow,
	workflows.GetWorkflowTemplate,
	workflows.SubmitWorkflowTemplate,
	workflows.UpdateWorkflowTemplate,
	workflows.DeleteWorkflowTemplate,
	workflows.GetWorkflowTemplates,

	reporting.reviewCycleGetForms,
	reportAnalytics.getReportAnalyticsInfo,
	reportAnalytics.deleteReportAnalytics,
	reportAnalytics.saveNewReportAnalytics,

	signatureTemplates.GetSignatureTemplate,
	signatureTemplates.GetSignatureTemplates,

	selectionObject.SelectionObjectCreate,
	selectionObject.SelectionObjectCountUsers,

	settings.getTimezones,
	settings.getUserSettings,
	settings.changeUserSetting,
	settings.GetCompanySettings,
	settings.getWeeklyDigestSettings,
	settings.changeUserDefaultCompany,
	settings.setWeeklyDigestNotification,
	settings.getAdminWeeklyDigestSettings,
	settings.getAsapAndDeferredNotification,
	settings.setAsapAndDeferredNotification,
	settings.setAdminWeeklyDigestNotification,
	settings.getWeeklyDigestSettingsTemplate,
	settings.setWeeklyDigestSettingsTemplate,
	settings.getAdminWeeklyDigestSettingsTemplate,
	settings.setAdminWeeklyDigestSettingsTemplate,
	settings.getAsapAndDeferredNotificationSettingsTemplate,
	settings.setAsapAndDeferredNotificationSettingsTemplate,
	settings.setSftpPassword,
	settings.getSftpPassword,
	settings.disableSftpPassword,

	asyncTasks.GetAsyncTasks,

	dashboard.getDashboardData,
	dashboard.GetDashboardPermissions,

	reviewForms.getReviewForms,

	reviewReports.getReviewReports,
];
